jQuery( function( $ ) {
	$( document ).ready( function() {

		utilsJS = ( function() {

			var
				init = function() {
					_smoothScroll();
				},

				_smoothScroll = function() {
					$( 'body' ).on( 'click', 'a[href*="#"]', function( e ) {
						var hash = this.hash;

						if ($('body').hasClass('page-template-template-covid')) {
							if ( '' !== hash ) {
								e.preventDefault();
								$( 'html, body' ).animate({
									scrollTop: $( hash ).offset().top - 125
								}, 700 );
							}
						} else {
							if ( $( window ).width() > 767 ) {
								if ( '' !== hash ) {
									e.preventDefault();
									$( 'html, body' ).animate({
										scrollTop: $( hash ).offset().top - 200
									}, 700 );
								}
							} else {
								if ( '' !== hash ) {
									e.preventDefault();
									$( 'html, body' ).animate({
										scrollTop: $( hash ).offset().top - 72
									}, 700 );
								}
							}
						}
					});
				}
			;

			return {
				init: init
			};

		}() );

	});
});
